import React from 'react';
import { LoadingCentered } from '.';

const LoadingOfModal = () => {
  return (
    <div
      style={{
        padding: '100px 0',
      }}
    >
      <LoadingCentered />
    </div>
  );
};

export default LoadingOfModal;
